export default __webpack_public_path__ + "static/media/19.43c6b10d.jpg";